import React from 'react';
import ArrowLeft from '@strapi/icons/ArrowLeft';
import ArrowRight from '@strapi/icons/ArrowRight';
import Cross from '@strapi/icons/Cross';
import ExclamationMarkCircle from '@strapi/icons/ExclamationMarkCircle';
import { Typography } from '@strapi/design-system/Typography';
import { CloseIcon } from '../StyledComponents';
import { Header } from '../StyledComponents';
import styles from '../AccessibilityChecker.module.css';
import { NEXT_BUTTON, PREV_BUTTON, TITLE_HEADER, TITLE_OF } from '../../../utils/constants';
export const Head = ({
  data,
  onPrev,
  onNext,
  onClose,
  count
}) => {
  const buttonStyles = `${styles.icon} ${styles['header-button']}`;
  const prevStyles = count?.current === 1 ? `${styles.inactive} ${buttonStyles}` : buttonStyles;
  const nextStyles = count?.current === count?.total ? `${styles.inactive} ${buttonStyles}` : buttonStyles;
  return /*#__PURE__*/React.createElement(Header, {
    background: "danger700",
    color: "neutral0"
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles.icon} ${styles['header-title']}`
  }, /*#__PURE__*/React.createElement(ExclamationMarkCircle, {
    className: styles['title-icon']
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "omega",
    fontWeight: "bold",
    textColor: "neutral0"
  }, TITLE_HEADER + count?.current + TITLE_OF + count?.total)), /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, /*#__PURE__*/React.createElement("div", {
    onClick: onPrev,
    className: prevStyles
  }, /*#__PURE__*/React.createElement(ArrowLeft, {
    className: styles['link-icon']
  }), /*#__PURE__*/React.createElement(Typography, {
    className: styles['header-button-text'],
    variant: "pi",
    fontWeight: "bold",
    textColor: "neutral0"
  }, PREV_BUTTON)), /*#__PURE__*/React.createElement("div", {
    onClick: onNext,
    className: nextStyles
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles['header-button-text'],
    variant: "pi",
    fontWeight: "bold",
    textColor: "neutral0"
  }, NEXT_BUTTON), /*#__PURE__*/React.createElement(ArrowRight, {
    className: styles['link-icon']
  })), /*#__PURE__*/React.createElement(CloseIcon, {
    background: "danger200",
    color: "neutral800",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Cross, {
    className: styles['header-icon']
  }))));
};